export const LOCALS = {
  EN: 'en',
  DE: 'de',
}